const ConnectionRetry = ({ onRetry = () => window.location.reload() }) => (
  <div role="alert" className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center">
    <p>Unable to connect. Please try again.</p>
    <button type="button" onClick={onRetry} className="rounded bg-blue-600 px-4 py-2 text-white">
      Retry
    </button>
  </div>
);

export default ConnectionRetry;
